const KEY = "cw_sim_offline";
const EVT = "cw-net-change";

export const isSimulatedOffline = () => typeof localStorage !== "undefined" && localStorage.getItem(KEY) === "1";
export const isOnline = () => (typeof navigator === "undefined" ? true : navigator.onLine) && !isSimulatedOffline();

export function setSimulatedOffline(on) {
  if (on) localStorage.setItem(KEY, "1"); else localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent(EVT, { detail: { online: isOnline() } }));
}

export function subscribeNet(handler) {
  const fire = () => handler(isOnline());
  window.addEventListener("online", fire);
  window.addEventListener("offline", fire);
  window.addEventListener(EVT, fire);
  return () => { window.removeEventListener("online", fire); window.removeEventListener("offline", fire); window.removeEventListener(EVT, fire); };
}
